export const CHECKOUT_URL = 'https://padel-pro-pack.impultienda.ar/checkout';
export const PRICE = {
  regular: '38 €',
  today: '19 €',
  amount: '19',
  totalValue: '94 €',
  bonusValue: '56 €'
};
export const metrics = [{
  label: 'Monitores activos',
  value: '+500'
}, {
  label: 'Tomos Maestros',
  value: '6'
}, {
  label: 'Páginas de contenido',
  value: '+120'
}, {
  label: 'Calificación',
  value: '4.8/5'
}, {
  label: 'Garantía de satisfacción',
  value: '7 días sin preguntas'
}];
export const testimonials = [{
  quote: 'Organicé todo el año en una tarde. La checklist de pista me ahorra más de 3 horas cada semana. Esto no tiene precio.',
  name: 'Marcela G.',
  country: 'Madrid'
}, {
  quote: 'Los tomos de táctica de pareja cambiaron la forma en que entreno a mis grupos. Mis alumnos progresan el doble de rápido y me lo dicen ellos mismos.',
  name: 'Carlos P.',
  country: 'Barcelona'
}, {
  quote: 'Mis grupos dejaron de ser un caos. El sistema de seguimiento es un antes y un después absoluto en mi club.',
  name: 'Roberto M.',
  country: 'Valencia'
}];
export const painPoints = ['Llegas al domingo sin saber exactamente qué vas a preparar para cada grupo.', 'Terminas buscando ejercicios en YouTube o Instagram a última hora.', 'Tienes alumnos de distintos niveles y te cuesta estructurar la sesión para cada uno.', 'Sabes que tus alumnos mejoran, pero no tienes forma de demostrárselo con evidencia real.', 'Quieres subir el precio de tu hora pero no sabes cómo justificarlo ante el club o el alumno.', 'La lluvia, la pista ocupada o un grupo sin energía te obligan a improvisar toda la sesión.', 'El fin de semana termina y vuelves a empezar el mismo ciclo agotador el próximo lunes.'];
export const tomos = [{
  id: 'T01',
  title: 'Mindset Sigma: De Monitor a Director de Academia',
  description: 'Deja de cobrar por hora y empieza a construir un negocio. El cambio de mentalidad que transforma tu carrera.'
}, {
  id: 'T02',
  title: 'Biomecánica, Técnica y Fondo de Pista',
  description: 'Cadena cinética, empuñadura, desplazamientos y golpes de fondo con una técnica que evita lesiones y maximiza el control.'
}, {
  id: 'T03',
  title: 'Dominio de Red, Bandeja y Víbora',
  description: 'Volea, bandeja, víbora y transiciones. Donde se ganan los partidos en el club. Enseña a tus alumnos a dominar la red sin miedo.'
}, {
  id: 'T04',
  title: 'Defensa Extrema, Paredes y Contrapared',
  description: 'Ángulos de rebote, giros, salidas de pared y globos bajo presión. Convierte a tus alumnos en muros infranqueables.'
}, {
  id: 'T05',
  title: 'Planificación Anual y Sesiones Listas (Niveles 1-5)',
  description: 'Sesiones mensuales y semanales listas para copiar y usar. Para Iniciación, Intermedio y Avanzado. Abre el PDF y la clase está resuelta.'
}, {
  id: 'T06',
  title: 'Preparación Física, Psicología y Negocio del Pádel',
  description: 'Circuitos en pista, gestión de grupos difíciles, cómo subir tus tarifas y fidelizar alumnos para que nunca se vayan con otro monitor.'
}];
export const includes = ['Acceso digital inmediato tras el pago', 'Para nivel Iniciación, Intermedio y Avanzado', 'Funciona para sesiones individuales y grupales', 'Lo abres desde el móvil, tablet u ordenador', 'Diseñado específicamente para el mercado español', 'Compatible con cualquier club, pista o academia de España'];
export const bonuses = [{
  number: '01',
  title: 'Padel Tracker Pro — El Sistema de Seguimiento Sigma',
  value: '14 €',
  cover: 'https://cdn.magicpatterns.com/uploads/dth86WrffrD6rbJH742DbC/BONO_1.png',
  description: "Controla la evolución de hasta 50 alumnos y genera informes de progreso automáticos. Demuestra resultados reales y justifica tus tarifas de monitor de élite."
}, {
  number: '02',
  title: 'WhatsApp Sales Scripts — Pista Llena en 60 Minutos',
  value: '12 €',
  cover: 'https://cdn.magicpatterns.com/uploads/ea5AiCdgMwrbfabqpLjwN8/BONO_2.png',
  description: "5 guiones de \"copiar y pegar\" para llenar pistas vacías por cancelaciones y vender bonos de 10 clases en minutos. Sin complicaciones y sin parecer un comercial."
}, {
  number: '03',
  title: 'La Checklist de Pista del Monitor de Élite',
  value: '12 €',
  cover: 'https://cdn.magicpatterns.com/uploads/up2XF5JGQwvqtVvuvSKLFD/BONO_3.png',
  description: "La hoja de ruta para una sesión impecable. Controla material, seguridad y los 3 puntos clave de feedback para que tus alumnos salgan alucinados de cada clase."
}, {
  number: '04',
  title: 'Guía Nutricional Sigma para Jugadores de Club',
  value: '10 €',
  cover: 'https://cdn.magicpatterns.com/uploads/aHThhJDyKuwrd5dZPnSsco/BONO_4.png',
  description: "Recurso listo para entregar a tus alumnos. Pautas de alimentación e hidratación pre/post partido que mejoran su rendimiento y te posicionan como un coach integral 360."
}, {
  number: '05',
  title: 'Vídeo-Análisis Express',
  value: '8 €',
  cover: 'https://cdn.magicpatterns.com/uploads/5jEawxBEJ1rLaM3bfrmVDQ/BONO_5.png',
  description: "Aprende a corregir con tu móvil como un analista pro. Descubre los 3 ángulos críticos y las apps gratuitas para dibujar líneas de corrección técnica en segundos."
}];
export const costOfInaction = [{
  without: '3 horas de planificación × 48 semanas',
  cost: '144 horas de tu vida por año'
}, {
  without: 'Alumnos sin progreso visible',
  cost: 'Abandono alto — ingresos inestables'
}, {
  without: 'Sesiones grupales improvisadas',
  cost: 'Energía quemada — calidad baja'
}, {
  without: 'Sin sistema de cobros ni agenda',
  cost: 'Dinero perdido cada semana'
}, {
  without: 'Sin variantes por nivel',
  cost: 'Alumnos frustrados y desconectados'
}, {
  without: 'Sin feedback ni seguimiento',
  cost: 'El mismo ciclo de búsqueda de alumnos'
}, {
  without: 'Cada fin de semana buscando en internet',
  cost: 'El mismo ciclo — el próximo año también'
}];
export const faqs = [{
  question: '¿Sirve para todos los niveles de pádel?',
  answer: 'Sí. El Pro-Pack incluye planificaciones, ejercicios y progresiones específicas para nivel Iniciación, Intermedio y Avanzado. Sin importar la mezcla de alumnos que tengas, siempre tendrás el recurso adecuado a mano.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Al confirmar el pago, recibes un email con el acceso inmediato a todos los PDFs. En menos de 5 minutos ya puedes abrir el Tomo 1 desde tu móvil, tablet u ordenador.'
}, {
  question: '¿Funciona si doy sesiones individuales y grupales?',
  answer: 'Absolutamente. El sistema está diseñado para ambos formatos. Cada tomo incluye variantes de adaptación para sesiones individuales y para grupos de hasta 12 personas.'
}, {
  question: '¿Qué lo diferencia de buscar ejercicios en YouTube?',
  answer: 'YouTube te da información aleatoria sin estructura ni progresión. El Padel Pro-Pack™ es un sistema metodológico que conecta cada ejercicio con un objetivo pedagógico claro. Es la diferencia entre improvisar y planificar con evidencia profesional.'
}, {
  question: '¿Está disponible para España?',
  answer: 'Sí. El Padel Pro-Pack™ está diseñado específicamente para el mercado español, con vocabulario, referencias y estándares de los clubes y academias de España. El pago puede realizarse con tarjeta, Stripe o Bizum.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. 7 días completos. Si no te convence, te devolvemos el 100% sin hacer preguntas. Menos del 1% de nuestros clientes la han utilizado.'
}];
export const images = {
  heroPack: 'https://cdn.magicpatterns.com/uploads/9LFeQSqaberr7G8J9UqLMv/ChatGPT_Image_12_ago_2026,_17_08_14.png',
  courtBg: 'https://cdn.magicpatterns.com/patterns/generated-images/5922b7c0-4082-406b-a4bf-9286996a70df.jpg',
  tomos: 'https://cdn.magicpatterns.com/uploads/sAgeCS5osmqSEL4bPqfZJp/CHECKOUT.png'
};